import { gql } from "@apollo/client";

const TERMINATE_IIA = gql`
  mutation terminateIIA($id: String!) {
    terminateIIA(id: $id)
  }
`;

export default TERMINATE_IIA;